import React from 'react';

export default function DatatableBottom(props) {
    return <div className="kt_datatable kt-datatable kt-datatable--default">{props.children}</div>;
}
